// extracted by mini-css-extract-plugin
module.exports = {"travelMenuTabs":"Menu_travelMenuTabs___RjcZ","navItemText":"Menu_navItemText__h_XmK","carSale":"Menu_carSale__awuxw"};